import { Button } from '@bymason-private/legacy-pattern-components';
import { ApiKeysView as ApiKeys } from '@bymason-private/controller-shared-widgets';
import { useState } from 'react';
import Layout from '../../common/layout';
import NoApiKeys from './no-api-keys';

export default function ApiKeysView() {
  const [showCreateApiKeyModal, setShowCreateApiKeyModal] = useState(false);

  const handleCreateApiKeyModalOpen = () => {
    setShowCreateApiKeyModal(true);
  };
  const handleCreateApiKeyModalClose = () => {
    setShowCreateApiKeyModal(false);
  };

  return (
    <Layout
      // busy={accountBusy}
      headerText='ApiKeys'
      headerRightAdornment={
        <Button variant='outlined' onClick={handleCreateApiKeyModalOpen}>
          Create API Key
        </Button>
      }
      stickyHeader
    >
      <ApiKeys
        showCreateApiKeyModal={showCreateApiKeyModal}
        onCloseCreateApiKeyModal={handleCreateApiKeyModalClose}
        emptyStateComponent={<NoApiKeys onCreateKeyModalOpen={handleCreateApiKeyModalOpen} />}
      />
    </Layout>
  );
}
